import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'fbDate' })
export class FirebaseDatePipe implements PipeTransform {
  transform(value: any, conf: string): string {
    const datePipe = new DatePipe('en-US');
    return datePipe.transform(new Date(value._seconds * 1000), conf);
  }
}
